import { ChainIdEnum } from "../../../enums/chain";
import { ChainConfig } from "../types";
import {
  DEFAULT_TOKEN_DECIMALS,
  EMPTY_ERC20,
  MARGINX_BRANDING,
} from "./shared";

// ============================================
// NONE (placeholder)
// ============================================
export const noneConfig: ChainConfig = {
  chainId: ChainIdEnum.NONE,
  name: "None",
  shortName: "none",
  isTestnet: false,
  rpcUrls: [],
  explorerUrl: "",
  l2ExplorerUrl: "",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  tokenDecimals: DEFAULT_TOKEN_DECIMALS,
  contracts: { erc20: EMPTY_ERC20 },
  signingDomain: { name: "Unknown", version: "1" },
  branding: MARGINX_BRANDING,
};
